import { extractDomain, getUuid } from 'common-utils';

import { useCookie } from './use-cookie';

function getTimeYearFromNow() {
  const now = new Date();
  return new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
}

export function useBigIntVisitorIdCookie(): string {
  const [cookie, setCookie] = useCookie<string>('__ivc', '');

  if (cookie.length <= 0 && typeof window !== 'undefined') {
    const visitorId = getUuid();
    const domain = extractDomain(window.location.hostname);
    setCookie(visitorId, {
      domain,
      expires: getTimeYearFromNow(),
      path: '/',
    });
    return visitorId;
  }

  return cookie;
}
